import "./InsightBlock.css";
import { useRef } from "react";
import { formatBoldText } from "../../../services/commonService";
import * as FeatherIcon from "react-feather";
import { useParams } from "react-router-dom";

import React, { useState } from "react";
import TopRightActionLinks from "./TopRightActionLinks";
import InfoTooltipIcon from "../../HtmlElements/InfoTooltipIcon";

function InsightBlock({
  title,
  overview,
  actions,
  pagePositives,
  pageNegatives,
  pageSoWhat,
}) {
  const [expandedItem, setExpandedItem] = useState(null);
  const { clientName, competitorName } = useParams();
  const handleToggle = (section, index) => {
    const key = `${section}-${index}`;
    setExpandedItem((prev) => (prev === key ? null : key));
  };

  const renderList = (items, section) => (
    <ul className="list_card_ul">
      {items.map((item, index) => {
        const text = typeof item === "object" ? item.value : item;
        const sources = typeof item === "object" ? item.sources : "";
        const reasoning = typeof item === "object" ? item.reasoning : "";
        const key = `${section}-${index}`;
        const isExpanded = expandedItem === key;
        return (
          <li
            key={key}
            title={"Click to see more"}
            className={`list_card_li ${isExpanded ? "expanded" : ""}`}
            onClick={() => handleToggle(section, index)}
          >
            <span className="list_card_text" style={{ textAlign: "justify" }}>
              {formatBoldText(text)}

              {isExpanded && sources && (
                <InfoTooltipIcon
                  payload={{
                    source: sources,
                    confidence_score: item.confidence_score,
                    data_type: item.data_type,
                    reasoning: reasoning,
                  }}
                  from={title}
                />
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <div className="company_overview_head_block">
        <div className="compnay_subblock_left">
          {title !== "Insight Summary Profile Market Position" && (
            <h6 className="company_overview_head">{title}</h6>
          )}
          <p className="compnay_overview_para" style={{ maxWidth: "100%" }}>
            {overview}
          </p>
        </div>
        <TopRightActionLinks actions={actions} section_type="company" />
      </div>
      <div className="insight_block">
        {(pagePositives?.length > 0 ||
          pageNegatives?.length > 0 ||
          pageSoWhat?.length > 0) && (
          <h5 className="insight_head">Insight Summary</h5>
        )}
        <div className="row">
          {pagePositives?.length > 0 && (
            <div className="col-md-4">
              <div className="card_block positive">
                <h6 className="head green_head">Positive</h6>
                {renderList(pagePositives, "positive")}
              </div>
            </div>
          )}

          {pageNegatives?.length > 0 && (
            <div className="col-md-4">
              <div className="card_block negative">
                <h6 className="head negative_head">Negative</h6>
                {renderList(pageNegatives, "negative")}
              </div>
            </div>
          )}

          {pageSoWhat?.length > 0 && (
            <div className="col-md-4">
              <div className="card_block neutral">
                <h6 className="head neutral_head">
                  Implication For {clientName || ""}
                </h6>
                {renderList(pageSoWhat, "sowhat")}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default InsightBlock;
